import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Link from 'react-router-dom/Link';
import ReactHtmlParser from 'react-html-parser';
import classnames from 'classnames';
import {withLocalize} from 'react-localize-redux';
import PlaceholderImage from '../../assets/img/placeholder-school-thumbnail.jpg';

class SchoolsListItem extends Component {
    onMouseEnter = () => {
        const {school} = this.props;

        this.props.setUiSchoolFocused(school.id);
    };

    onMouseLeave = () => {
        this.props.setUiSchoolFocused(0);
    };

    render() {
        const {school, index, idSchoolFocused} = this.props;

        let url = this.props.translate('routes.schools_details').replace(':slug', school.slug);

        let addressStreet = school.address_line1;
        if (school.address_line2 !== '') {
            addressStreet += '<br />' + school.address_line2;
        }

        let thumbnailStyles = {};

        if (school.background_image && school.background_image.listing && school.background_image.listing !== '') {
            thumbnailStyles = {
                backgroundImage: 'url("' + school.background_image.listing + '")',
            };
        } else {
            thumbnailStyles = {
                backgroundImage: `url(${PlaceholderImage})`,
            };
        }

        const displayedIndex = index + 1;

        return (
            <div className="col col-12 col-md-6 col-lg-4" key={school.id} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
                <Link to={url} className={classnames('item', {
                    'hover': (idSchoolFocused === school.id),
                })}>
                    {/*<div className="number d-none d-lg-block"><span>{displayedIndex}</span></div>*/}
                    <div className="thumbnail" style={thumbnailStyles}></div>
                    <span className="title">{ReactHtmlParser(school.title)}</span>
                    <div className="address">
                        <span className="city">{school.address_postal_code} {ReactHtmlParser(school.address_city)}</span>
                        <span className="street">{ReactHtmlParser(addressStreet)}</span>
                    </div>
                </Link>
            </div>
        );
    }
}

SchoolsListItem.propTypes = {
    school: PropTypes.object.isRequired,
    setUiSchoolFocused: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
};

export default withLocalize(SchoolsListItem);


// WEBPACK FOOTER //
// ./src/features/Schools/components/List/SchoolsListItem.js